/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

export enum TSBeitragArt {
    FONDSSUISSE = <any>'FONDSSUISSE',
    FONDSSUISSE_2023 = <any>'FONDSSUISSE_2023',
    KANTON = <any>'KANTON',
    HOCHGEBIRGE = <any>'HOCHGEBIRGE',
    VERSICHERUNG = <any>'VERSICHERUNG',
}

const year2023 = 2023;

export function getTSBeitragArtSchadenfallValues(): Array<TSBeitragArt> {
    return [
        TSBeitragArt.FONDSSUISSE,
        TSBeitragArt.FONDSSUISSE_2023,
        TSBeitragArt.KANTON,
        TSBeitragArt.HOCHGEBIRGE,
    ];
}

export function getTSBeitragArtValues(): Array<TSBeitragArt> {
    return [
        TSBeitragArt.FONDSSUISSE,
        TSBeitragArt.FONDSSUISSE_2023,
        TSBeitragArt.KANTON,
        TSBeitragArt.HOCHGEBIRGE,
        TSBeitragArt.VERSICHERUNG,
    ];
}

export function getDefaultTSBeitragArtValues(): Array<TSBeitragArt> {
    return [
        TSBeitragArt.FONDSSUISSE_2023,
        TSBeitragArt.KANTON,
        TSBeitragArt.HOCHGEBIRGE,
        //TSBeitragArt.VERSICHERUNG,
    ];
}

export function getTSBeitragArtValuesByYear(year: number): Array<TSBeitragArt> {
    let beitragArts = [
        TSBeitragArt.KANTON,
        //TSBeitragArt.VERSICHERUNG,
    ];

    if (year >= year2023) {
        beitragArts.splice(0, 0, TSBeitragArt.FONDSSUISSE_2023);
    } else {
        beitragArts.splice(0, 0, TSBeitragArt.FONDSSUISSE);
        beitragArts.splice(2, 0, TSBeitragArt.HOCHGEBIRGE);
    }

    return beitragArts;
}

export function beitragArtPrefix(): string {
    return 'TSBeitragArt_';
}

export function beitragPropertySuffix(): string {
    return '_BEITRAG';
}




// WEBPACK FOOTER //
// ./src/app/models/enums/TSBeitragArt.ts